import { render } from "./customInvoicingModel.vue?vue&type=template&id=4ee717f8"
import script from "./customInvoicingModel.vue?vue&type=script&lang=js"
export * from "./customInvoicingModel.vue?vue&type=script&lang=js"

import "./customInvoicingModel.vue?vue&type=style&index=0&id=4ee717f8&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__